import { gql } from '@apollo/client';

export const QUOTE_CHANGELOG_VIEW_MODEL_FRAGMENT = gql`
  fragment QuoteChangelogViewModelFields on QuoteChangeLogViewModel {
    id
    changes
    parentId
    accountId
    changeType
    createdDateTime
    modifiedBy {
      id
      fullName
    }
  }
`;
